import React,{Component} from 'react';
import { NavLink,Link } from 'react-router-dom'
import logo from './images/logo.png'
import Category from './images/Category.png'


export class Header extends Component {
  state = {
    isShow:false
  }

   handleClick= (e)=>{
     this.setState({isShow:!this.state.isShow})
   }
    render(){
        return (<div className='header' id='header'>
                    <div className='header-inner max-width-box'>
                        <div className='header-left'>
                            <Link to='/'>
                                <img id='logo' className='logo' alt='新运力官网logo' style={{marginTop:'15px'}} src={ logo }/>
                            </Link>
                        </div>
                        <div className='header-right phone-nav' ref='phone-nav' style={this.state.isShow?{display:'block'}:null}>
                            {/* exact不加会出现两个选中颜色 */}
                            <NavLink exact  to='/' >首页</NavLink>
                            <NavLink to='/productService'>产品服务</NavLink>
                            <NavLink to='/aboutUs'>关于我们</NavLink>
                            <NavLink to='/joinUs'>加入我们</NavLink>
                        </div>
                        <a className='category'onClick={this.handleClick} href='javascript:;'><img src={Category} alt='导航分类' width='32' height='32'/></a>

                    </div>
            </div>
            )
    }
   
}




// WEBPACK FOOTER //
// ./src/components/header/index.js